import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'mo' })
export class MomentPipe implements PipeTransform {
    transform(value: Date | moment.Moment): any {
        return moment(value).format('Y/M/D HH:mm');
    }
}